import { RegionCode } from '@steelbuy/ts-shared';
import { Vendor } from './vendorTypes';

export const regionToVendor = (region?: RegionCode): Vendor => {
    if (!region) {
        return 'default';
    }
    switch (region) {
        case 'us':
            return 'TNA';
        default:
            return 'default';
    }
};
